module.exports = __webpack_public_path__ + "assets/media/2.a0a48914.wav";